import { compose } from 'recompose';

import UsersFilter from './UsersFilter';

const enhance = compose();

export default enhance(UsersFilter);
